<app-loading-spinner [active]="loading"></app-loading-spinner>

<div class="row no-gutters" [formGroup]="form">
    <div class="col-12 offset-lg-1 col-lg-10">

        <!-- Card do perfil - aparece antes dos campos quando existe perfil -->
        <div class="row"
            *ngIf="data && (data.score || not_declared || data.profile || data.is_exempt) && !isFund">
            <div class="col-12 d-flex align-items-center justify-content-end">
                <div
                    style="background: linear-gradient(135deg, #001030 0%, #001847 100%); border-radius: 12px; padding: 28px 32px; margin-bottom: 32px; box-shadow: 0 4px 12px rgba(0, 16, 48, 0.2); position: relative; overflow: hidden; width: 100%; max-width: 100%;">
                    <!-- Decorative circle -->
                    <div
                        style="position: absolute; top: -40px; right: -40px; width: 150px; height: 150px; background: rgba(196, 171, 116, 0.15); border-radius: 50%;">
                    </div>
                    <div
                        style="position: absolute; bottom: -60px; left: -60px; width: 180px; height: 180px; background: rgba(196, 171, 116, 0.1); border-radius: 50%;">
                    </div>

                    <div
                        style="position: relative; z-index: 1; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 24px;">
                        <div style="flex: 1; min-width: 200px;">
                            <p *ngIf="!data.is_exempt"
                                style="margin: 0 0 8px 0; font-size: 11px; color: rgba(255, 255, 255, 0.8); font-weight: 600; text-transform: uppercase; letter-spacing: 0.8px;">
                                Seu perfil é
                            </p>
                            <p
                                style="margin: 0; font-size: 32px; font-weight: 800; color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); line-height: 1.2;">
                                {{ data.is_exempt ? 'DISPENSADO POR NORMA CONF. ICVM 30, ART. 10 itens II, III Ou IV' : getRiskLabel() }}
                            </p>
                            <p *ngIf="getEnquadramentoLabel() && !data.is_exempt"
                                style="margin: 10px 0 0 0; font-size: 16px; color: rgba(255, 255, 255, 0.92); font-weight: 700; letter-spacing: 0.2px;">
                                {{ getEnquadramentoLabel() }}
                            </p>
                        </div>

                        <div style="display: flex; gap: 40px; flex-wrap: wrap;" *ngIf="!data.is_exempt">
                            <div>
                                <span
                                    style="font-size: 10px; color: rgba(255, 255, 255, 0.7); display: block; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.6px; font-weight: 600;">
                                    Data de início
                                </span>
                                <span
                                    style="font-size: 16px; color: #ffffff; font-weight: 700; letter-spacing: 0.2px;">
                                    {{data.start_date | date: 'dd/MM/yyyy' ??
                                    '-'}}
                                </span>
                            </div>
                            <!-- <div>
                                <span
                                    style="font-size: 10px; color: rgba(255, 255, 255, 0.7); display: block; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.6px; font-weight: 600;">
                                    Data de expiração
                                </span>
                                <span
                                    style="font-size: 16px; color: #ffffff; font-weight: 700; letter-spacing: 0.2px;">
                                    {{getExpireDate() | date: 'dd/MM/yyyy' ??
                                    '-'}}
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Questionário - escondido quando perfil existe e showQuestionnaire é false -->
        <ng-container *ngIf="showQuestionnaire">
            <ng-container *ngFor="let option of options; let i = index">
                <div class="row">
                    <div class="col-12 col-lg-10">
                        <span
                            *ngIf="form.controls[option.formControl].value === null"
                            class="is-required">*</span>
                        <span
                            class="basic-content-subtitle">{{option.title}}</span>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row"
                    *ngFor="let suboption of option.suboptions;let i = index">

                    <div class="offset-1 col-9">
                        <app-radio
                            [isChecked]="form.controls[option.formControl].value === suboption.value"
                            [formControlName]="option.formControl"
                            [value]="suboption.value">
                            <div class="flex-1 d-flex flex-column">
                                <span
                                    class="basic-content-description"><strong>{{i+1}})</strong>
                                    {{suboption.label}}</span>
                            </div>
                        </app-radio>

                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                </div>

                <app-spacer [bottom]="24"></app-spacer>
            </ng-container>

            <app-spacer [bottom]="48"></app-spacer>
        </ng-container>

        <!-- Botões para quando o questionário está escondido -->
        <div class="row"
            *ngIf="!showQuestionnaire && data && (data.score || not_declared || data.profile || data.is_exempt) && !isFund">
            <div class="col-12 d-flex align-items-center justify-content-end">
                <app-button (onClick)="showQuestionnaireForm()"
                    [outline]="true">
                    {{ not_declared ? 'Declarar perfil de investidor' :
                    'Responder novamente' }}
                </app-button>
            </div>
        </div>

        <!-- Botões de ação - só aparecem quando o questionário está visível -->
        <div class="row" *ngIf="showQuestionnaire && !isFund">
            <div
                class="col-12 d-flex align-items-center justify-content-between">
                <app-button (onClick)="showQuestionnaire = false"
                    [outline]="true" [disabled]="sending || refusing">
                    Cancelar
                </app-button>

                <div class="d-flex align-items-center">
                    <app-button (onClick)="toggleRefuseModal(true)"
                        [outline]="true" [disabled]="sending || refusing"
                        [loading]="refusing" type="submit">
                        {{ (data && (data.score || data.profile) &&
                        !not_declared) ? 'Remover perfil' : 'Pular questionário'
                        }}
                    </app-button>

                    <app-spacer [right]="16"></app-spacer>

                    <app-button (onClick)="applyNormDispense()" [outline]="true"
                        [disabled]="sending || refusing" [loading]="refusing"
                        type="submit">
                        DISPENSA POR NORMA CONF. ICVM 30, ART. 10 itens II, III ou IV
                    </app-button>

                    <app-spacer [right]="16"></app-spacer>

                    <app-button (onClick)="checkProfile()"
                        [disabled]="sending || !form.valid" [loading]="sending"
                        type="submit">
                        Salvar dados
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-warning-modal [active]="redirectWarning" [hideCloseButton]="true">
    <h3>Atenção</h3>
    <app-spacer [bottom]="24"></app-spacer>

    <p>Para prosseguir, é necessário completar a etapa
        <strong>Dados complementares: {{missingGeneralData ? 'Geral' : 'Fundos
            de interesse'}}.</strong>
    </p>

    <app-spacer [bottom]="56"></app-spacer>

    <app-button class="add-button" (onClick)="redirectUser()" [center]="true">
        ok
    </app-button>
</app-warning-modal>

<!-- Modal de confirmação para remover/pular questionário -->
<app-carbon-warning-modal [active]="refuseModal && showConfirmRefuse"
    [disableClose]="true" [loading]="refusing" title="Confirme sua decisão?"
    message="<p>Caso prossiga com a invalidação do questionário, seu perfil de investidor será definido como Não declarado.</p><p>Deseja continuar?</p>"
    confirmText="Sim" cancelText="Não" [confirmAction]="handleConfirmRefuse"
    [cancelAction]="handleCancelRefuse">
</app-carbon-warning-modal>

<!-- Modal inicial perguntando se deseja retornar e responder -->
<app-carbon-warning-modal [active]="refuseModal && !showConfirmRefuse"
    [disableClose]="true" [loading]="false" title="Atenção"
    message="<p>É necessário responder as questões de avaliação de perfil de investidor.</p><p>Deseja retornar e responder as questões?</p>"
    confirmText="Sim" cancelText="Não" [confirmAction]="handleReturnToQuestions"
    [cancelAction]="handleShowConfirmRefuse">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showDisqualificationModal"
    [disableClose]="true" [loading]="sending"
    title="Atenção - Desenquadramento de Perfil"
    [message]="'<p><strong>Seu perfil de investidor não se enquadra nos critérios de público alvo do fundo de interesse.</strong></p><p>Ao clicar em &quot;Sim, estou ciente do desenquadramento&quot;, você estará <strong>aceitando explicitamente o desenquadramento</strong> e assumindo a responsabilidade por esta decisão.</p><p>Deseja continuar mesmo assim?</p>'"
    confirmText="Sim, estou ciente do desenquadramento"
    cancelText="Não, quero refazer"
    [confirmAction]="handleAcceptDisqualification"
    [cancelAction]="handleRefuseDisqualification">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showDispenseModal" [disableClose]="true"
    [loading]="refusing" title="Atenção - Dispensa por Norma"
    message="<p><strong>Você será dispensado de responder o questionário de perfil de investidor conforme ICVM 30, Art. 10, itens II, III ou IV.</strong></p><p>Será necessário comprovar a dispensa na etapa de anexos.</p><p>Deseja prosseguir mesmo assim?</p>"
    confirmText="Sim, desejo prosseguir" cancelText="Não, quero responder"
    [confirmAction]="handleConfirmDispense"
    [cancelAction]="handleCancelDispense">
</app-carbon-warning-modal>